var _ = require('underscore/underscore');
var Backbone = require('backbone/backbone');
var SubSection = require('front/pages/Section/SubSection');

var template = require('./BasePopup.jinja');
require('./BasePopup.less');

var Utils = require('front/utils/Utils');

module.exports = SubSection.extend({
    template: template,

    el: '.BasePopup',

    baseEvents: {
        'click .BasePopup-close': 'close',
        'click .BasePopup-bg': 'close',
        'click .BasePopup-print': 'onPrintClick',
        'click .BasePopup-download': 'onDownloadClick'
    },


    apiUrl: function () {
        return undefined;
    },


    initialize: function (options) {
        SubSection.prototype.initialize.call(this, options);

        _.bindAll(this, 'apiUrl', 'onKeydown', 'onResize', 'keyDownOn', 'keyDownOff', 'onNavHidden', 'onNavVisible');

        $(window).on('resize', this.onResize);


        if (options.server) {
            this.$el.hide();
            this.$el.addClass('BasePopup--visible');
            this.$el.outerHeight();
            this.$el.show();
            this.triggerPopupShown();
            this.$('.BasePopup-content').scrollTop(0);
            this.$('.BasePopup-content').focus(); //for pgdn pgup shortcuts
            this.fromServer = true;

            this.data = {}; //prevent api call for data when opens from direct url
        }

        this.keyDownOn();

        window.app.vent.on('MemberProfileEdit-openPopup', this.keyDownOff);
        window.app.vent.on('MemberProfileEdit-closePopup', this.keyDownOn);

        window.app.vent.on('nav-hidden', this.onNavHidden);
        window.app.vent.on('nav-visible', this.onNavVisible);
    },


    onNavHidden: function () {
        this.$el.addClass('BasePopup--nav-hidden');
    },


    onNavVisible: function () {
        this.$el.removeClass('BasePopup--nav-hidden');
    },


    onPrintClick: function () {

    },


    onDownloadClick: function () {

    },


    keyDownOn: function () {
        $(window).on('keydown', this.onKeydown);
    },


    keyDownOff: function () {
        $(window).off('keydown', this.onKeydown);
    },


    onResize: function () {
        var self = this;

        positionButtons();

        //resize of REM content takes some time
        setTimeout(positionButtons, 100);
        setTimeout(positionButtons, 500);

        function positionButtons() {
            var $content = self.$('.BasePopup-content');
            if (!$content.length) return;
            var leftPos = $content.offset().left + $content.width() - self.$('.BasePopup-close').width();
            self.$('.BasePopup-close, .BasePopup-print, .BasePopup-download').css('left', leftPos);
        }
    },


    onKeydown: function (e) {
        if (e.keyCode == 27) { //esc
            this.close();
        }
    },


    triggerPopupShown: function () {
        this.savedScroll = $(window).scrollTop();
        app.vent.trigger('PopupShown', {isBlack: this.$el.hasClass('BasePopup--transparentLeft') || this.$el.hasClass('BasePopup--black')});
        $(window).scrollTop(0);
        this.$el.addClass('BasePopup--animation-in-progress');
    },


    triggerPopupHidded: function () {
        app.vent.trigger('PopupHidded');
        $(window).scrollTop(this.savedScroll);
        this.$el.removeClass('BasePopup--animation-in-progress');
    },


    close: function () {
        app.router.navigateBack();
    },


    // renderData: function () {
    //     return {
    //         newsItem: this.data.newsItem
    //     };
    // },


    // render: function () {
    //     var result = SubSection.prototype.render.call(this);
    //     this.initializeComponents();

    //     return result;
    // },


    activate: function (params) {
        return SubSection.prototype.activate.call(this, params)
            .then(function () {
                this.$content = this.$('.BasePopup-content');
            }.bind(this));
    },

    //on animation end
    onPopupShown: function () {
        this.$el.removeClass('BasePopup--animation-in-progress');
    },


    //on animation end
    onPopupHidded: function () {
        this.$el.addClass('BasePopup--animation-in-progress');
    },


    playIn: function (params) {
        var self = this;
        clearTimeout(self.popupShowAnimationTimeout);
        clearTimeout(self.popupShowResolveTimeout);

        if (this.options.inAnimated) {
            return new Promise(function (resolve) {
                if (params.duration) {
                    self.$el.outerHeight();
                    self.onResize();
                    self.triggerPopupShown();

                    //to fix animation gliches while content load
                    self.popupShowAnimationTimeout = setTimeout(function () {
                        self.$el.addClass('BasePopup--visible');
                    }, 220);

                    self.popupShowResolveTimeout = setTimeout(function () {
    //                    this.$('.BasePopup-content').focus();//for keys pgup, pgdown etc to scroll popup, not global
                        self.onPopupShown();
                        resolve();
                    }, params.duration + 220);
                } else {
                    self.$el.hide();
                    self.$el.addClass('BasePopup--visible');
                    self.$el.outerHeight();
                    self.onResize();
                    self.$el.show();
                    self.triggerPopupShown();
                    self.onPopupShown();
                    resolve();
                }
            });
        } else {
            self.onPopupShown();

            return Utils.createEmptyPromise();
        }
    },


    playOut: function (params) {
        var self = this;

        clearTimeout(self.popupShowAnimationTimeout);
        clearTimeout(self.popupShowResolveTimeout);

        return new Promise(function (resolve) {
            self.$el.removeClass('BasePopup--visible');
            self.onPopupHidded();

            if (params.duration) {
                app.utils.waitForTransitionEnd(self.$('.BasePopup-wrapper'), 'transform', function () {
                    self.triggerPopupHidded();
                    resolve();
                }.bind(this), params.duration);
            } else {
                self.triggerPopupHidded();
                resolve();
            }
        });
    },


    viewsRegistration: function () {
        this.onResize();

        if (this.fromServer) {
            this.onPopupShown();
        }

        SubSection.prototype.viewsRegistration.call(this);
    },


    destroy: function () {
        this.keyDownOff();
        $(window).off('resize', this.onResize);

        window.app.vent.off('MemberProfileEdit-openPopup', this.keyDownOff);
        window.app.vent.off('MemberProfileEdit-closePopup', this.keyDownOn);

        window.app.vent.off('nav-hidden', this.onNavHidden);
        window.app.vent.off('nav-visible', this.onNavVisible);

        return SubSection.prototype.destroy.call(this);
    },


    deactivate: function (params) {
        this.triggerPopupHidded();

        return SubSection.prototype.deactivate.call(this, params);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/BasePopup/BasePopup.js
// module id = 8
// module chunks = 0